<!-- 柱状图 -->
<style lang="less" scoped>
.bar-wrap {
  width: 48900/1920vw;
  height: 22vh;
  margin: 0 auto;
  overflow: hidden;
  .swiper-wrap {
    width: 48900/1920vw;
    height: 23500/1080vh;
  }

  .swiper-slide {
    height: 4700/1080vh;
    background: url("../../../../../assets/img/yinxiao/title.png") no-repeat;
    background-size: 100% 100%;
  }

  .list {
    color: #fff;
    .list-item {
      height: 4700/1080vh;
      .name {
        color: #fff;
        width: 29%;
        line-height: 5000/1080vh;
        font-size: 16px;
        font-weight: 400;
        float: left;
        margin-left: 1500/1080vh;
        margin-right: 1500/1080vh;
        color: rgba(255, 255, 255, 1);
        overflow: hidden; /*内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        white-space: nowrap;
        span {
          height: 15px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(107, 157, 224, 1);
          margin-right: 10px;
          // line-height: 46px;
        }
      }

      .length {
        margin-right: 2000/1080vh;
        float: left;
        margin-top: 2150/1080vh;
        width: 46%;
        height: 700/1080vh;
        background: #22387f;
        border-radius: 5px;
        .active {
          height: 700/1080vh;
          border-radius: 5px;
          // background: linear-gradient(
          //   45deg,
          //   rgba(36, 199, 104, 1) 0%,
          //   rgba(255, 222, 0, 1) 50%,
          //   rgba(255, 120, 0, 1) 75%,
          //   rgba(36, 199, 104, 1) 100%
          // );
          background: linear-gradient(
            45deg,
            rgba(36, 199, 104, 1) 0%,
            rgba(255, 222, 0, 1) 33%,
            rgba(255, 120, 0, 1) 66%,
            rgba(36, 199, 104, 1) 100%
          );

          animation: move 10s linear infinite;
          // margin-top: -5px;
        }
      }

      .num {
        line-height: 5000/1080vh;
        font-size: 16px;
        margin-right: 1000/1080vh;
        float: right;
        width: 12%;
        color: #70a4e9;
      }
    }
    @keyframes move {
      0% {
        background-position: -500px 0;
      }
      100% {
        background-position: 0 0;
      }
    }

    // .list-item .length .cur {
    //   background: linear-gradient(
    //     to right,
    //     #fcc94a,
    //     #ff8700
    //   ) !important; /* 标准的语法 */
    // }

    // .list-item .length .cur1 {
    //   background: linear-gradient(
    //     to right,
    //     #c0e450,
    //     #75cd2d
    //   ) !important; /* 标准的语法 */
    // }

    // .list-item .length .cur2 {
    //   background: linear-gradient(
    //     to right,
    //     #5eb5ff,
    //     #217dfb
    //   ) !important; /* 标准的语法 */
    // }

    // .list-item:nth-child(1) .length .active {
    //   width: 90%;
    //   background: #006cff;
    //   border-radius: 5px;
    // }

    // .list-item:nth-child(2) .length .active {
    //   // width: 70%;
    //   background: linear-gradient(90deg, #fcc94a, #ff8700);
    // }

    // .list-item:nth-child(3) .length .active {
    //   // width: 60%;
    //   background: linear-gradient(90deg, #c0e450, #75cd2d);
    // }

    // .list-item:nth-child(4) .length .active {
    //   // width: 50%;
    //   background: linear-gradient(90deg, #c0e450, #75cd2d); /* 标准的语法 */
    // }

    // .list-item:nth-child(5) .length .active {
    //   // width: 40%;
    //   background: linear-gradient(90deg, #5eb5ff, #217dfb); /* 标准的语法 */
    // }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <swiper
        :options="swiperOption"
        class="swiper-wrap"
        ref="mySwiper"
        v-if="tableData.length != 0"
      >
        <swiper-slide
          v-for="(item, index) in tableData"
          :key="index"
          class="list"
        >
          <div class="list-item">
            <div class="name">
              <span>{{ index + 1 }}</span
              >{{ item.id }}
            </div>
            <div class="length">
              <div
                class="active"
                :class="cla(index)"
                :style="`width:${(item.productionForecast / sum) * 100}%`"
              ></div>
            </div>
            <div class="num">{{ item.productionForecast }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import bar from "components/dashboard/bar";
import echarts from "echarts";

import "@/assets/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
      myChart: {},
      name: "会员购买商品排行",
      tableData: [],
      arr: [
        "会员积分兑换产品排行",
        "会员扫码产品排行",
        "会员参加活动排行",
        "会员购买商品排行"
      ],
      list: {
        会员积分兑换产品排行: [
          { id: "随机红包0.5～1元", productionForecast: 39987 },
          { id: "光明纯牛奶250ml", productionForecast: 30231 },
          { id: "滴滴打车优惠券（随机)", productionForecast: 25121 },
          { id: "天猫超市优惠券（随机)", productionForecast: 22123 },
          { id: "燕之屋燕窝70g", productionForecast: 20313 },
          { id: "茅台体验装", productionForecast: 18219 },
          { id: "帮宝适纸尿裤1片装", productionForecast: 16213 },
          { id: "婴儿泡泡沐浴露", productionForecast: 12312 },
          { id: "曼哈顿儿童咬胶", productionForecast: 10742 },
          { id: "花王纸尿裤1片装", productionForecast: 9490 }
        ],
        会员扫码产品排行: [
          { id: "光明新鲜杯优倍200ml", productionForecast: 609987 },
          { id: "光明纯牛奶250ml", productionForecast: 590231 },
          { id: "光明莫斯利安常温酸牛奶200g", productionForecast: 424121 },
          { id: "光明优加纯牛奶250ml", productionForecast: 353123 },
          {
            id: "光明中老年奶粉高钙维生素E调制奶粉听装800g",
            productionForecast: 300313
          },
          {
            id: "光明优倍高品质巴氏杀菌鲜牛奶950ml",
            productionForecast: 287219
          },
          { id: "光明随心订致优全鲜乳尊享杯260ml", productionForecast: 255213 },
          { id: "光明噜渴酸奶盒装200ml", productionForecast: 202312 },
          { id: "光明如实洋槐蜂蜜发酵乳135g", productionForecast: 198742 },
          { id: "光明巧克力味含乳饮料250ml", productionForecast: 158490 }
        ],
        会员参加活动排行: [
          { id: "微信红包", productionForecast: 599987 },
          { id: "大转盘抽奖", productionForecast: 450231 },
          { id: "翻牌活动", productionForecast: 394121 },
          { id: "扫码拿抵扣券", productionForecast: 353123 },
          {
            id: "刮刮乐活动",
            productionForecast: 292313
          },
          {
            id: "微信抽免单",
            productionForecast: 253219
          },
          { id: "签到领积分", productionForecast: 213213 },
          { id: "投篮领抵扣券", productionForecast: 192312 },
          { id: "集印花领红包", productionForecast: 158742 },
          { id: "一起猜歌名", productionForecast: 128490 }
        ],
        会员购买商品排行: [
          { id: "帮宝适纸尿裤", productionForecast: 109987 },
          { id: "美赞臣荷兰版铂睿幼儿配方奶粉", productionForecast: 99987 },
          { id: "life space婴儿益生菌粉", productionForecast: 97623 },
          {
            id: "lifeline care婴幼儿宝宝鱼油DHA维D3",
            productionForecast: 83412
          },
          {
            id: "费雪欢乐成长玩具套餐",
            productionForecast: 80213
          },
          {
            id: "曼哈顿咬胶婴幼儿咬胶",
            productionForecast: 75213
          },
          { id: "花王纸尿裤", productionForecast: 64352 },
          { id: "德国施巴婴儿泡泡沐浴露", productionForecast: 45099 },
          { id: "儿童声波软毛电动牙刷", productionForecast: 42812 },
          { id: "利其尔透透杯系列", productionForecast: 24123 }
        ]
      },
      sum: 0,
      index: 0,
      swiperOption: {
        slidesPerView: "auto",
        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    };
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  methods: {
    cla(index) {
      if (index === 1) {
        return "cur";
      }
      if (index === 2) {
        return "cur1";
      }
      if (index === 3) {
        return "cur2";
      }
    },
    getData() {
      this.tableData = [];
      this.index = this.index + 1;
      if (this.index >= 4) {
        this.index = 0;
      }
      this.name = this.arr[this.index];
      console.log(this.name);
      this.tableData = this.list[this.arr[this.index]];
      this.sum = this.list[this.arr[this.index]][0].productionForecast * 1.1;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, 10000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?57c9d48d